import React from 'react';
import { compose, range} from 'ramda';

import styleFile from './AvailServiceDetail.js';
import RichText from '@synergycms_core/components/generic/RichText';

import { roomCanAddService, boardCanAddService } from '../../../store/avail/availUtils';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';


import {
  SERVICE_TYPE_PER_USE
} from '../../../config/constants';
import CheckBox from '@synergycms_core/components/generic/CheckBox';

const ServiceUseSelect = props => (
    <div>
        <RichText icon={{ unicodeContent: 'E052' }} innerStyle={props.classes.selectIcon} />
        <select value={props.value} onChange={props.onChange(props.idx)}>
        {range(0, 11).map(value => (
            <option key={value} value={value}>
            {value}
            </option>
        ))}
        </select>
    </div>
);
  
const ServiceCheckbox = props => (
    <CheckBox 
        value={props.value} 
        onChange={props.onChange(props.idx, props.value)} 
        code={props.code}
        innerStyle={'extrasChecked'} />
);

class AvailServiceRoomDetail extends React.Component {

    render() {

        const { 
            block, 
            service, 
            classes, 
            serviceType, 
            serviceBlocks, 
            changeServiceQuantity, 
            changeBlockService,
            key
        } = this.props.config;

        if (roomCanAddService(service)(block) && boardCanAddService(service)(block)) {
            const idx = block.get('idx');
            const bookedService =
                block.get('services').find(s => s.get('service_id') === serviceBlocks.getIn([idx, 'service_id'], false)) ||
                false;

            const quantity = bookedService ? bookedService.get('quantity') : 0;

            return (
                <div key={key} className={classes.roomDetailLine}>
                    <div className={classes.roomDetail}>
                        <RichText text={'_%habitación%_'} innerStyle={['roboto20Black', 'capitalize']} translate={true} />
                        <RichText text={' ' + idx} innerStyle={['roboto20Black']} />
                    </div>
                    {serviceType === SERVICE_TYPE_PER_USE && (
                        <div className={classes.roomDetailDescription}>
                            <RichText
                                translate={true}
                                ucFirst={true}
                                text={serviceType === SERVICE_TYPE_PER_USE ? '_%cantidad%_' : ''}
                                innerStyle={['roboto16SoftGray']}
                            />
                        </div>
                    )}
                    <div className={classes.roomDetailCheck}>
                        {serviceType === SERVICE_TYPE_PER_USE ? (
                            <ServiceUseSelect classes={classes} value={quantity} onChange={changeServiceQuantity} idx={idx} />
                        ) : (
                            <ServiceCheckbox
                                value={!!bookedService}
                                checked={!!bookedService}
                                idx={idx}
                                code={service.get('id') + '-' + idx}
                                onChange={changeBlockService}
                            />
                        )}
                    </div>
                </div>
            );
        } else {
            return false;
        }
    }
}
    
export default compose(
    PropertyManager([
      'classes',
      'service',
      'block',
      'serviceType',
      'changeServiceQuantity',
      'changeBlockService',
      'serviceBlocks',

    ]),
    withThemeJSS({ styleFile, link: true })
  )(AvailServiceRoomDetail);
  